var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Page',{attrs:{"title":"Users & Access"}},[_c('Access',{ref:"access"}),_c('v-btn',{attrs:{"to":"/resetPWD","outlined":"","color":"secondary"}},[_vm._v("Reset My Password")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }